// extracted by mini-css-extract-plugin
export var box = "_9e-1";
export var checkboxRow = "_9e-8";
export var checked = "_9e-2";
export var descriptionSpacer = "_9e-a";
export var disabled = "_9e-3";
export var icon = "_9e-6";
export var input = "_9e-0";
export var labelSpacer = "_9e-9";
export var medium = "_9e-5";
export var small = "_9e-4";
export var text = "_9e-7";